/** Public menu URL for QR codes (per deployment). Falls back to current origin in the browser. */
export const getMenuPublicUrl = () => {
  const fromEnv = import.meta.env?.VITE_MENU_PUBLIC_URL?.trim();
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
};

export const SUPABASE_NOT_CONFIGURED_MSG =
  'Supabase non configuré. Vérifiez VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans .env, puis redémarrez ou reconstruisez l\'application.';
